import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right-bracket",
  "use": "right-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-bracket\"><path d=\"M30,514 L39.0062975,514 C44.5256666,514 48.9999993,509.524905 48.9999993,504.000011 L48.9999993,493.999989 C48.9999993,488.477148 44.5230513,484 39.0062975,484 L30.0001521,484 C35.3543354,486.862855 38.9958588,492.506227 38.9958588,499 C38.9958588,505.494893 35.3536929,511.13749 30,514 Z\" transform=\"translate(-30 -484)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/right-bracket.svg
// module id = 732
// module chunks = 0